import { AdditionServicesOptionsState } from './additionServicesOptionsContext';

/**
 * Дефолтный стейт опций доп. услуг.
 */
export class DefaultServiceOptionsState implements AdditionServicesOptionsState {
  FieldOptions = {};
  FieldsToCalculateState = [];
  LangID = '';
  Loadings = [];
  Cache = {
    switch: { isPartialLoading: true, cache: {} },
    hidden: { isPartialLoading: true, cache: {} },
    tax: { isPartialLoading: true, cache: {} },
    location: { isPartialLoading: true, cache: {} },
    number: { isPartialLoading: true, cache: {} },
    handbook: { isPartialLoading: true, cache: {} },
    currency: { isPartialLoading: true, cache: {} },
    consulting_contractor: { isPartialLoading: true, cache: {} },
    inspection_contractor: { isPartialLoading: true, cache: {} },
    customs_contractor: { isPartialLoading: true, cache: {} },
    certification_contractor: { isPartialLoading: true, cache: {} },
    insurance_contractor: { isPartialLoading: true, cache: {} },
    package: { isPartialLoading: true, cache: {} },
    product: { isPartialLoading: true, cache: {} },
  };
}
